import { apiRequest, toQueryString } from './apiRequest';

export const aiAgentsAPI = {
  listSkills: async () => {
    return await apiRequest<any>('/api/ai/skills', { method: 'GET' });
  },
  listAgentTags: async () => {
    return await apiRequest<any>('/api/ai/agent-tags', { method: 'GET' });
  },
  listAgentTemplates: async () => {
    return await apiRequest<any>('/api/ai/agent-templates', { method: 'GET' });
  },
  listAgents: async ({ scope = 'all' } = {}) => {
    return await apiRequest<any>(`/api/ai/agents${toQueryString({ scope })}`, { method: 'GET' });
  },
  getDefaults: async () => {
    return await apiRequest<any>('/api/ai/defaults', { method: 'GET' });
  },
  updateDefaults: async (payload) => {
    return await apiRequest<any>('/api/ai/defaults', {
      method: 'PATCH',
      body: JSON.stringify(payload ?? {}),
    });
  },
  getAgent: async (id) => {
    return await apiRequest<any>(`/api/ai/agents/${id}`, { method: 'GET' });
  },
  createAgent: async (payload) => {
    return await apiRequest<any>('/api/ai/agents', {
      method: 'POST',
      body: JSON.stringify(payload ?? {}),
    });
  },
  updateAgent: async (id, payload) => {
    return await apiRequest<any>(`/api/ai/agents/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload ?? {}),
    });
  },
  duplicateAgent: async (id, payload) => {
    return await apiRequest<any>(`/api/ai/agents/${id}/duplicate`, {
      method: 'POST',
      body: JSON.stringify(payload ?? {}),
    });
  },
  createAgentFromTemplate: async (payload) => {
    return await apiRequest<any>('/api/ai/agents/from-template', {
      method: 'POST',
      body: JSON.stringify(payload ?? {}),
    });
  },
  deleteAgent: async (id) => {
    return await apiRequest<any>(`/api/ai/agents/${id}`, { method: 'DELETE' });
  },

  listThreads: async ({ scope = 'all', agentId = '' } = {}) => {
    return await apiRequest<any>(
      `/api/ai/threads${toQueryString({ scope, agentId: agentId || undefined })}`,
      { method: 'GET' }
    );
  },
  createThread: async (payload) => {
    return await apiRequest<any>('/api/ai/threads', {
      method: 'POST',
      body: JSON.stringify(payload ?? {}),
    });
  },
  getThread: async (id) => {
    return await apiRequest<any>(`/api/ai/threads/${id}`, { method: 'GET' });
  },
  deleteThread: async (id) => {
    return await apiRequest<any>(`/api/ai/threads/${id}`, { method: 'DELETE' });
  },
  generateThreadTitle: async (threadId) => {
    return apiRequest<any>(`/api/ai/threads/${threadId}/title`, { method: 'PATCH' });
  },

  listMemory: async ({ scope = 'private', agentId = '' } = {}) => {
    return await apiRequest<any>(
      `/api/ai/memory${toQueryString({ scope, agentId: agentId || undefined })}`,
      { method: 'GET' }
    );
  },
  createMemory: async (payload) => {
    return await apiRequest<any>('/api/ai/memory', {
      method: 'POST',
      body: JSON.stringify(payload ?? {}),
    });
  },
  updateMemory: async (id, payload) => {
    return await apiRequest<any>(`/api/ai/memory/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload ?? {}),
    });
  },
  deleteMemory: async (id) => {
    return await apiRequest<any>(`/api/ai/memory/${id}`, { method: 'DELETE' });
  },

  submitFeedback: async (payload) => {
    return await apiRequest<any>('/api/ai/feedback', {
      method: 'POST',
      body: JSON.stringify(payload ?? {}),
    });
  },
  getAgentAnalytics: async (agentId) => {
    const qs = agentId ? `?agentId=${encodeURIComponent(agentId)}` : '';
    return await apiRequest<any>(`/api/ai/analytics/agents${qs}`, { method: 'GET' });
  },
  getFeedbackSummary: async ({ days = 30 } = {}) => {
    return apiRequest<any>(`/api/ai/analytics/feedback-summary?days=${days}`, { method: 'GET' });
  },
};
